const colorsWhite = {
  'color-white': '#ffffff',
};

module.exports = colorsWhite;
